import { App } from 'vue'

import AIAssistantIcon from '@/common/ai-assistant/AIAssistantIcon.vue'
import AppActionBar from '@/common/app-action-bar/AppActionBar.vue'
import AppActionBarListItem from '@/common/app-action-bar/AppActionBarListItem.vue'
import AppBulkList from '@/common/app-bulk-list/AppBulkList.vue'
import AppEmptyState from '@/common/AppEmptyState.vue'
import AppGrid from '@/common/AppGrid.vue'
import AppGridDetailItem from '@/common/AppGridDetailItem.vue'
import AppGridItem from '@/common/AppGridItem.vue'
import AppSignatureStatus from '@/common/AppSignatureStatus.vue';
import AppTextDivider from '@/common/AppTextDivider.vue'
import AppTitleBar from '@/common/AppTitleBar.vue'
import FiltersDrawer from '@/common/FiltersDrawer.vue'
import AppIconImanage from '@/common/imanage/AppIconImanage.vue'
import AppIconPolyOffice from '@/common/polyOffice/AppIconPolyOffice.vue'
import ShareDrawer from '@/common/ShareDrawer.vue'
import VersioningDrawer from '@/common/VersioningDrawer.vue'
import AppAlertInPage from '@/design-system/alert/AppAlertInPage.vue'
import AppAvatar from '@/design-system/AppAvatar.vue'
import AppSegmentedControl from '@/design-system/AppSegmentedControl.vue'
import AppBadge from '@/design-system/badge/AppBadge.vue'
import AppButton from '@/design-system/buttons/AppButton.vue'
import AppButtonAlert from '@/design-system/buttons/AppButtonAlert.vue'
import AppDropdownButton from '@/design-system/buttons/dropdown-button/AppDropdownButton.vue'
import AppDropdownButtonItem from '@/design-system/buttons/dropdown-button/AppDropdownButtonItem.vue'
import FileSizeDisplay from '@/design-system/display/FileSizeDisplay.vue'
import AppDrawer from '@/design-system/drawers/AppDrawer.vue'
import AppIconBadge from '@/design-system/icons/AppIconBadge.vue'
import AppMaterialIcon from '@/design-system/icons/AppMaterialIcon.vue'
import AppToggle from '@/design-system/inputs/AppToggle.vue'
import AppModal from '@/design-system/modals/AppModal.vue'
import AppTile from '@/design-system/tiles/AppTile.vue'
import AppTileGroup from '@/design-system/tiles/AppTileGroup.vue'
import AppTreeviewItem from '@/design-system/treeview/AppTreeviewItem.vue'
import AppHeadline from '@/design-system/typography/AppHeadline.vue'

export function globallyRegisterDesignSystemComponents (app: App) {
  // alert
  app.component('app-alert-in-page', AppAlertInPage)

  // buttons
  app.component('app-button', AppButton)
  app.component('app-button-alert', AppButtonAlert)
  app.component('app-dropdown-button', AppDropdownButton)
  app.component('app-dropdown-button-item', AppDropdownButtonItem)
  app.component('app-segmented-control', AppSegmentedControl)

  // badge
  app.component('app-badge', AppBadge)

  // display
  app.component('app-filesize-display', FileSizeDisplay)

  // icons
  app.component('app-material-icon', AppMaterialIcon)
  app.component('app-icon-badge', AppIconBadge)

  app.component('app-icon-imanage', AppIconImanage)
  app.component('app-icon-poly-office', AppIconPolyOffice)
  app.component('app-icon-ai-assistant', AIAssistantIcon)

  // inputs
  app.component('app-toggle', AppToggle)

  // tiles
  app.component('app-tile', AppTile)
  app.component('app-tile-group', AppTileGroup)
  
  // modals
  app.component('app-modal', AppModal)

  // drawers
  app.component('app-drawer', AppDrawer)
  app.component('app-filters-drawer', FiltersDrawer)
  app.component('app-share-drawer', ShareDrawer)
  app.component('app-versioning-drawer', VersioningDrawer)

  // treeview
  app.component('app-treeview-item', AppTreeviewItem)

  // typography
  app.component('app-headline', AppHeadline)

  // misc
  app.component('app-avatar', AppAvatar)
  app.component('app-empty-state', AppEmptyState)
  app.component('app-text-divider', AppTextDivider)

  // grid item
  app.component('app-grid', AppGrid)
  app.component('app-grid-item', AppGridItem)
  app.component('app-grid-detail-item', AppGridDetailItem)

  // action bar
  app.component('app-action-bar', AppActionBar)
  app.component('app-action-bar-list-item', AppActionBarListItem)

  // title bar
  app.component('app-title-bar', AppTitleBar)

  // bulk summary
  app.component('app-bulk-list', AppBulkList)

  // signature
  app.component('app-signature-status', AppSignatureStatus)
}
